export const isShopPreview = (query: Record<string, any>) => query.is_preview || query.cabinet_preview
